const LOAD_DATA_MASTER_CLIENTS           = 'LOAD_DATA_MASTER_CLIENTS'
const LOAD_DATA_MASTER_CLIENTS_SUCCESS   = 'LOAD_DATA_MASTER_CLIENTS_SUCCESS'
const LOAD_DATA_MASTER_CLIENTS_FAILED    = 'LOAD_DATA_MASTER_CLIENTS_FAILED'
const UNMOUNT_DATA_MASTER_CLIENTS        = 'UNMOUNT_DATA_MASTER_CLIENTS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const masterClientReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_CLIENTS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_CLIENTS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_CLIENTS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_CLIENTS:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default masterClientReducer;